import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import moment from 'moment';
import { useCheckoutStoreContext } from '../../context';
import MenuProduct from '../CheckoutProductsTab/Menu/components/MenuProduct/MenuProduct';
import { modalStore } from 'src/mobx/modalStore';
import { IMenuProduct } from 'src/types/products';
import Text from 'src/view/components/Text/Text';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { DELIVERY_TYPE } from '~/constants/deliveryTypes';
import './style.scss';

const CheckoutSummaryCartProducts: FC = observer((): ReactElement => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const onProductSelect = useCallback(
    (product: IMenuProduct) => {
      modalStore.openOrderProduct({
        id: product.id,
        product,
        branch: checkoutStore.dependencies.branch,
        onSubmit: checkoutStore.updateProduct,
        error: product.error,
        isEdit: true,
        isDraft: checkoutStore.isDraft,
        time: checkoutStore.params.preorder && checkoutStore.params.preorder_date ? moment(checkoutStore.params.preorder_date).unix() : undefined,
        orderType: checkoutStore.params.is_dinein ? DELIVERY_TYPE.DINE_IN : (checkoutStore.params.delivery_type as DELIVERY_TYPE),
      });
    },
    [checkoutStore.isDraft]
  );

  return (
    <div className="mt-6">
      <Text type="section-header" text="txt_cart" />
      <ScrollableBlock
        showScrollbar
        scrollbarSize="small"
        direction="horizontal"
        className="checkout-summary-cart-products__scroll-wrapper"
        scrollClassName="checkout-summary-cart-products__scroll"
      >
        {checkoutStore.dependencies.products.map((product, index) => (
          <MenuProduct key={String(product.id) + '-' + String(index)} index={index} product={product} onSelect={onProductSelect} />
        ))}
      </ScrollableBlock>
    </div>
  );
});

export default CheckoutSummaryCartProducts;
